// A value of 0x00 indicates BER.
export const BIT_MASK_DER: number = 0x10000000_00000000;
export const BIT_MASK_BAPER: number = 0x01000000_00000000;
export const BIT_MASK_BUPER: number = 0x00100000_00000000;
export const BIT_MASK_XER: number = 0x00010000_00000000;
